import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { LinkTile } from 'reaxl';

const PriceAdvisorReport = memo(({
    link,
    ...rest
}) => (
    <LinkTile
        data-cmp="priceAdvisorReport"
        link={{ ...link, offsite: true }}
        {...rest}
    />
));

PriceAdvisorReport.propTypes /* remove-proptypes */ = {
    /**
    * The className to apply to the root node
    */
    className: PropTypes.string,
    /**
     * tile object
     */
    image: PropTypes.shape({
        /**
         * src for tile image
         */
        src: PropTypes.string,
        /**
         * title for tile image
         */
        title: PropTypes.string,
    }),
    link: PropTypes.shape({
        /**
         * The anchor
         */
        href: PropTypes.string,
        /**
         * The alt
         */
        alt: PropTypes.string,
        /**
         * The label to anchor
         */
        label: PropTypes.string,
        /**
         * The flag to trigger offsite glyphicon
         */
        offsite: PropTypes.bool,
    }),
    /**
     * optional callback for tile
     */
    onTileClick: PropTypes.func,
    /**
     * optional callback for anchor
     */
    onLinkClick: PropTypes.func,
};

export default PriceAdvisorReport;
